import { render, staticRenderFns } from "./VAlignBottom.vue?vue&type=template&id=6f55fe66&scoped=true&"
var script = {}
import style0 from "./VAlignBottom.vue?vue&type=style&index=0&id=6f55fe66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f55fe66",
  null
  
)

export default component.exports